import { useRef } from 'react';
import { ReactComponent as CloseStrokeSVG } from '../../icons/close-stroke.svg';
import { useOutsideClick } from '../../helpers/clickOutside';

const Modal = ({ title, content, onClose, onDelete, onClickOutside }) => {
  const modalRef = useRef(null);
  useOutsideClick(modalRef, onClickOutside);

  return (
    <div
      className="fullscreen-modal-container"
      style={{ visibility: 'visible' }}
    >
      <div className="fullscreen-modal-background"></div>
      <div className="fullscreen-modal fullscreen-modal-action fullscreen-modal-wide">
        <section className="modal-content" ref={modalRef}>
          <header className="modal-header">
            <h1>{title}</h1>
          </header>
          <span onClick={() => onClose()} className="pointer close">
            <CloseStrokeSVG />
          </span>

          <div className="modal-body">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>

          <div className="modal-footer flex items-end">
            <button className="btn-white" onClick={onClose}>
              <span>Cancel</span>
            </button>
            <button className="btn-red" onClick={onDelete}>
              <span>Delete</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Modal;
